export type IOnBoardAccountStatus = 'unattempted' | 'onboarded' | 'error';

export interface IOnboardingAccount {
	account_uuid: string;
	arn: string;
	id: string;
	account_alias?: string;
	company_name?: string;
	onboarding_status?: IOnBoardAccountStatus;
	reonboarding: boolean;
	cur_bucket_name?: string;
}

export class PermissionNode {
	children?: PermissionNode[];
	parent?: PermissionNode;
	name: string;
	permanent?: boolean;
}

export interface IOnboardingTask {
	message: string;
	org_id: string;
	task_id: string;
}

export enum OnboardingSteps {
	selectProvider = 'select_provider',
	connectAccount = 'connect_account',
	verifyIntegration = 'verify_integration',
	completeSetup = 'complete_setup',
	onboardingQueue = 'onboarding_queue',
	selectPermissions = 'select_permissions',
}

export interface IStepListItem {
	title: string;
	description: string;
	step: OnboardingSteps;
	hidden?: boolean;
	icon?: string;
}

export enum CurRadioOptions {
	notMaster = 'not-master',
	yesEnabled = 'yes-enabled',
}

export type IStepListItems = IStepListItem[];

export interface IAWSJSONPreview {
	AWSTemplateFormatVersion: string;
	Description: string;
	Metadata?: any;
	Parameters?: any;
	Resources?: any;
	Outputs?: any;
}

export interface OnboardingStatusDTO {
	status: 'Started' | 'Pending' | 'Success' | 'Failed';
	msg: string;
}

export interface OnboardingApiKeyPayload {
	permissions_list: string[];
	region: string;
}

export interface OnboardingPermissionsMapDTO {
	regions: Object[];
	all_permissions: Object;
	current_roles: Object[];
}

export interface OnboardingApiKeyDTO {
	onboardingPid: string;
	cli: string;
}
